// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: 'AIzaSyA_rh_S3csNwxoJzD3BWxk8PVTAgHmLS0o',
	authDomain: 'wedding-94824.firebaseapp.com',
	projectId: 'wedding-94824',
	storageBucket: 'wedding-94824.appspot.com',
	messagingSenderId: '119553693415',
	appId: '1:119553693415:web:d6d285fbfd64ece263f442',
	measurementId: 'G-X6BNFGQ2SR'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const auth = getAuth(app)
export const firestoreDb = getFirestore(app)

// Local testing against the Firebase emulator suite.
//
// Opt-in, never automatic. The check is an explicit env flag rather than
// NODE_ENV or a hostname sniff on purpose: `npm start` has always pointed at
// the live production project, so anything that silently redirected it would
// change what a developer's existing habits do. You have to ask for the
// emulator, and `.env.local` is where you ask (see README-emulator.md).
//
// Create React App inlines REACT_APP_* at build time, so a production build
// literally cannot contain the emulator branch unless the flag was set when
// that build ran.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
	const host = '127.0.0.1'

	connectAuthEmulator(auth, `http://${host}:9109`, { disableWarnings: true })
	connectFirestoreEmulator(firestoreDb, host, 8090)

	// endpoint/index.ts calls getFunctions() with no arguments, which resolves
	// to this same default-app instance — so connecting it here is what routes
	// every callable in the app to the emulator.
	connectFunctionsEmulator(getFunctions(app), host, 5011)

	console.warn('[firebase] Using LOCAL EMULATORS - no production data is being touched.')
}
